/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { sandboxParams } from 'app/scripts/data/plugin-iframe-sandbox';
import { teacupWithHelpers } from 'app/scripts/views/internal/teacupWithHelpers';
import { PluginView } from 'app/scripts/views/plugin/PluginView';
const t = teacupWithHelpers();

const template = t.renderable(function (param) {
  if (param == null) {
    param = {};
  }
  const { content } = param;
  switch (content.type) {
    case 'iframe':
      t.iframe('.plugin-iframe', {
        allow: 'microphone; camera',
        sandbox: sandboxParams,
        src: content.url,
      });
      t.div('.plugin-iframe-popover-overlay');
      break;
    default:
  }
});

class PluginOverlayView extends PluginView {
  static initClass() {
    this.prototype.className = 'plugin-overlay js-plugin-iframe-container';
  }
  initialize({ content }) {
    this.content = content;
    return this.retain(this.content);
  }

  renderOnce() {
    this.$el.html(template({ content: this.content }));
    this.initIFrames(this.model);
    return this;
  }
}
PluginOverlayView.initClass();
export { PluginOverlayView };
